module.exports = __webpack_public_path__ + "static/media/qr-step3.cfc284f0.svg";